import request from "@/lib/api/handler";
import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "../utils";
import { AdminPayment } from "@/types";

export const useAdminPaymentsQuery = () => {
  const { getAccessTokenSilently } = useAuth0();
  const {
    data: adminPayments,
    error: adminPaymentsError,
    isLoading: adminPaymentsLoading,
  } = useQuery({
    queryKey: QueryKeys.adminPayments,
    enabled: true,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    async queryFn() {
      const token = await getAccessTokenSilently();
      return await request<AdminPayment[]>({
        method: "GET",
        path: "/api/admin/payments",
        token,
      });
    },
  });

  return {
    adminPayments,
    adminPaymentsError,
    adminPaymentsLoading,
  };
};
